import { useState } from 'react';
import { recordEventCustomOnly } from 'utilities/uTagging';
import {
    doTagOpenDocumentList,
    doTagReOpenDocumentList,
    doTagShowDocumentsModal,
} from 'components/newAccountSteps/initialStep/documentation/tagging';

const getOrderedDocumentsForDisplay = (documentsList, documentToOpen) => {
    if (!documentToOpen) return documentsList.filter(document => !document.isAccepted);

    const { prevDocuments, nextDocuments, firstDocument } = documentsList.reduce(
        (acc, document) => {
            if (document.documentType === documentToOpen.documentType) {
                return { ...acc, firstDocument: document };
            }
            if (document.isAccepted) return acc;
            if (!acc.firstDocument) return { ...acc, prevDocuments: [...acc.prevDocuments, document] };

            return { ...acc, nextDocuments: [...acc.nextDocuments, document] };
        },
        { prevDocuments: [], nextDocuments: [], firstDocument: null }
    );

    return [firstDocument, ...nextDocuments, ...prevDocuments];
};

export const useDocumentsModal = ({ isDocumentsLoaded, documentsList, onLoadDocuments, onClose }) => {
    const [showDocumentModal, setShowDocumentModal] = useState(false);
    const [documentsToOpen, setDocumentsToOpen] = useState([]);

    const handleCloseDocumentsModal = (event, scrollPercentage) => {
        event.preventDefault();
        recordEventCustomOnly({
            categoriaEvento: '/onboarding/abre-tu-cuenta/',
            accionEvento: 'precontractual/modal',
            etiquetaEvento: `documento scroll ${scrollPercentage}%`,
        });
        onClose?.();
        setShowDocumentModal(false);
    };
    const handleOpenDocumentsModal = (documentsList, documentToOpen) => {
        const documentsToOpen = getOrderedDocumentsForDisplay(documentsList, documentToOpen);
        setDocumentsToOpen(documentsToOpen);
        setShowDocumentModal(true);
        doTagShowDocumentsModal(documentsToOpen[0]);
    };
    const handleShowDocumentsModal = documentToOpen => {
        const isSomedocumentAccepted = documentsList.some(document => document.isAccepted);
        const isNotFirstTimeOpening = isDocumentsLoaded && (isSomedocumentAccepted || documentToOpen);

        isNotFirstTimeOpening && doTagReOpenDocumentList(documentToOpen);
        !isNotFirstTimeOpening && doTagOpenDocumentList(documentToOpen);

        if (isDocumentsLoaded) {
            handleOpenDocumentsModal(documentsList, documentToOpen);
        } else {
            const callback = documents => handleOpenDocumentsModal(documents, documentToOpen);
            onLoadDocuments(callback);
        }
    };

    return {
        showDocumentModal,
        documentsToOpen,
        setDocumentsToOpen,
        handleShowDocumentsModal,
        handleCloseDocumentsModal,
    };
};
